
import Collapsible from '@/components/Collapsible.vue';
import { DosageTimeRange } from '@/service/models/request/computation/dosage-time-range';
import { useRequestDataStore } from '@/store/request-data';
import { defineComponent, ref } from 'vue';
import EditModal from './EditModal.vue';
import DosageRow from './DosageRow.vue';
import ConcentrationChart from '@/components/ConcentrationChart.vue';
import { useChartsStore } from '@/store/charts';
import ChartSettingsModal from '@/components/ChartSettingsModal.vue';
import { DosageSteadyState } from '@/service/models/common/query-dosage/parts/dosage-steady-state';

export default defineComponent({
    components: {
        ChartSettingsModal,
        Collapsible,
        ConcentrationChart,
        DosageRow,
        EditModal,
    },

    setup()
    {
        const isDosageModalOpen = ref(false);
        const isSettingsModalOpen = ref(false);
        const modalDosageIndex = ref(0);
        const selectedDosageIndex = ref(0);
        const modalData = ref<DosageTimeRange|null>(null);
        const isSteadyStateAllowed = ref(true);

        const requestData = useRequestDataStore();
        const chartStore = useChartsStore();

        function openDosageModal(dosageIndex: number|null): void
        {
            if (dosageIndex === null) {
                modalDosageIndex.value = requestData.dosages.length;
                modalData.value = null;
            }
            else {
                modalDosageIndex.value = dosageIndex;
                modalData.value = requestData.dosages[dosageIndex];
            }

            // There can be only one dosage at Steady state
            isSteadyStateAllowed.value = true;
            for (let i = 0; i < requestData.dosages.length; i++) {
                if (i === dosageIndex) {
                    continue;
                }

                if (requestData.dosages[i].dosage.dosageRepeat instanceof DosageSteadyState) {
                    isSteadyStateAllowed.value = false;
                    break;
                }
            }

            isDosageModalOpen.value = true;
        }

        function openSettingsModal()
        {
            isSettingsModalOpen.value = true;
        }

        function handleSave(payload: {index: number, data: DosageTimeRange})
        {
            // Save data in the store
            requestData.dosages[payload.index] = payload.data;
        }

        return {
            requestData,
            chartStore,
            selectedDosageIndex,
            handleSave,
            openDosageModal, isDosageModalOpen, modalDosageIndex, modalData, isSteadyStateAllowed,
            openSettingsModal, isSettingsModalOpen,
        };
    }
})
